import { createFileRoute } from '@tanstack/react-router';
import { EventsPage } from '../../features/community';

export const Route = createFileRoute('/portal/events/')({ component: EventsPage });
